import React from 'react';
import { Flex, Text, useColorModeValue } from '@chakra-ui/react';
import logo from '../assets/logo.png';
import BrandIcon from './BrandIcon';
import { BUILD_INFO } from '../buildInfo';

/**
 * Minimal retained Basix mark (item 35) — a quiet "powered by" line instead
 * of the old image banner, sitting directly on the skin's canvas. Carries the
 * auto-generated build version (scripts/gen-version.js) so the deployed build
 * is always identifiable; hover for branch + build time.
 */
const BasixFooter: React.FC = () => {
  const color = useColorModeValue('blackAlpha.500', 'whiteAlpha.400');
  const versionColor = useColorModeValue('blackAlpha.400', 'whiteAlpha.300');
  return (
    <Flex direction="column" align="center" justify="center" py={6} gridGap={1} color={color}>
      <Flex align="center" gridGap={2}>
        <BrandIcon src={logo} color={color} w="28px" h="14px" mr={0} />
        <Text fontSize="xs" letterSpacing="0.18em" fontWeight="medium">
          POWERED BY BASIX BOOKS
        </Text>
      </Flex>
      {/* item 1266 (Chad) — the product slogan rides the mark */}
      <Text fontSize="0.65rem" letterSpacing="0.08em" fontStyle="italic">
        The Basix Six — the items you need to outsource your accounting.
      </Text>
      <Text
        fontSize="0.65rem"
        letterSpacing="0.1em"
        color={versionColor}
        title={`build ${BUILD_INFO.build} · ${BUILD_INFO.branch} · ${BUILD_INFO.builtAt} · “${BUILD_INFO.codename}”`}
      >
        v
        {BUILD_INFO.semver}
        {' '}
        ·
        {' '}
        {BUILD_INFO.commit}
      </Text>
    </Flex>
  );
};

export default BasixFooter;
